export { default as BOTMyAppointmentsDetailsMyGarage } from '../MyGarage2.0/components/BOTMyAppointmentsDetailsMyGarage'
